import _toConsumableArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import { Utils } from "../support";

var get = require("lodash/get");

var compact = require("lodash/compact");

export var Accessor =
/*#__PURE__*/
function () {
  function Accessor() {
    _classCallCheck(this, Accessor);

    this.active = true;
    this.translations = {};
    this.refCount = 0;
  }

  _createClass(Accessor, [{
    key: "incrementRef",
    value: function incrementRef() {
      this.refCount++;
    }
  }, {
    key: "decrementRef",
    value: function decrementRef() {
      this.refCount--;
    }
  }, {
    key: "setActive",
    value: function setActive(active) {
      this.active = active;
      return this;
    }
  }, {
    key: "setSearchkitManager",
    value: function setSearchkitManager(searchkit) {
      this.searchkit = searchkit;
      this.uuid = searchkit.guid();
      this.results = this.searchkit.results;
    }
  }, {
    key: "translate",
    value: function translate(key, interpolations) {
      var translation = this.searchkit && this.searchkit.translate(key) || this.translations[key] || key;
      return Utils.translate(translation, interpolations);
    }
  }, {
    key: "getResults",
    value: function getResults() {
      return this.results;
    }
  }, {
    key: "setResults",
    value: function setResults(results) {
      this.results = results;
    }
  }, {
    key: "getAggregations",
    value: function getAggregations(path, defaultValue) {
      var results = this.getResults();
      var getPath = compact(['aggregations'].concat(_toConsumableArray(path)));
      return get(results, getPath, defaultValue);
    }
  }, {
    key: "beforeBuildQuery",
    value: function beforeBuildQuery() {}
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      return query;
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      return query;
    }
  }]);

  return Accessor;
}();